import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/data/brand";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory px-6">
      <div className="bg-white border border-gold/25 rounded-md p-12 max-w-md w-full text-center shadow-[0_20px_50px_rgba(27,42,71,0.10)]" data-testid="payment-cancel-page">
        <div className="flex items-center justify-center gap-3 mb-6">
          <img src={LOGO_URL} alt="The Ever Grace Group" className="h-12 w-12 rounded-full object-cover" />
          <span className="font-serif text-2xl text-navy"><span className="text-navy">Ever</span> <span className="text-gold">Grace</span></span>
        </div>
        <XCircle className="w-12 h-12 text-charcoal/40 mx-auto mb-4" />
        <h1 className="font-serif text-3xl text-navy mb-2">Checkout cancelled</h1>
        <p className="text-charcoal/70 mb-6">No charge was made. You can pick a plan whenever you're ready.</p>
        <Button onClick={() => navigate("/pricing")} data-testid="return-pricing-btn"
          className="bg-navy hover:bg-navy/90 text-ivory rounded-full px-8">View plans</Button>
      </div>
    </div>
  );
}
